import angular from 'angular';
import tableGridIconExtendedCellComponent from './tableGridIconExtendedCell.component';

let tableGridIconExtendedCellModule = angular.module('tableGridIconExtendedCell', []).directive('tableGridIconExtendedCell', tableGridIconExtendedCellComponent);

export default tableGridIconExtendedCellModule;



// WEBPACK FOOTER //
// ./app/components/tableGridIconExtendedCell/tableGridIconExtendedCell.js